import Slick from 'vue-slick';
//import 'slick-carousel/slick/slick.scss';

import template from './slider.vhtml';

export default {
	components: {
		Slick,
	},
	template,
	props: {
		sliderItems: {
			'type': Array,
			'default': null,
		},
		perPage: {
			'type': Number,
			'default': 1,
		},
		dotsClass: {
			type: String,
			default: 'slider__dots',
		}
	},
	data() {
		return {
			currentItem: null,
			items: [],
			location: 0,
			counter: 1,
			navigatedRight: false,
			slickOptions: {
				centerMode: true,
				slidesToShow: this.perPage,
				slidesToScroll: this.perPage,
				arrows: false,
				dots: true,
				dotsClass: this.dotsClass,
				easing: 'cubic-bezier( .395, .325, .365, .995 )',
				centerPadding: '15%',
				responsive: [
					{
						breakpoint: 2000,
						settings: {
							centerPadding: '8%',
						}
					},
					{
						breakpoint: 600,
						settings: {
							centerPadding: '14px',
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					},
				]
			},
		}
	},
	computed: {
		showSlick() {
			return this.items.length > 0;
		},
	},
	methods: {
		next() {
			this.page += 1;
			this.$refs.slick.next();
		},
		prev() {
			this.page -= 1;
			this.$refs.slick.prev();
		},
	},
	mounted() {
		this.items = this.sliderItems;
	},
}


// WEBPACK FOOTER //
// ./assets/_js/components/slider/slider.js